'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1he52_1";
const styles = {
	root: root
};

const ButtonGroup = ({ children, columnSize = "minmax(0, 1fr)", justify = "start", maxWidth = "initial" }) => {
  return React__default.default.createElement("div", { "data-zds": true, className: styles.root, style: {
    "--_zds-button-group-max-width": maxWidth,
    "--_zds-button-group-justify": justify,
    "--_zds-button-group-column-size": columnSize
  } }, children);
};

exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=ButtonGroup.cjs.js.map
